import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FabricanteService } from 'app/services/fabricante.service';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-fabricante-form',
  templateUrl: './fabricante-form.component.html',
  styleUrls: ['./fabricante-form.component.scss']
})
export class FabricanteFormComponent implements OnInit {
  public id_fabricante: number;
  public nome: string;
  public cnpj: string;
  public telefone: string;
  public email: string;
  public endereco: string;
  public isLoading = false;
  public flg_status: number = 1;

  public href;
  public contentHeader: object;
  private routeSub: Subscription;

  constructor(
    private route: ActivatedRoute,
    private fabricanteService: FabricanteService,
    private _router: Router
  ) { }

  ngOnInit() {
    this.href = this.route.url;

    if (this.href.value[1].path == "cadastro") {
      this.contentHeader = {
        headerTitle: "Cadastrar Fabricante",
        actionButton: false,
        breadcrumb: {
          type: "",
          links: [
            { name: "Início", isLink: false },
            { name: "Fabricante", isLink: false },
            { name: "Cadastrar", isLink: false }
          ]
        }
      };
    }

    if (this.href.value[1].path == "editar") {
      this.routeSub = this.route.params.subscribe(async (params) => {
        try {
          const fabricante = await this.fabricanteService.getOne(params["id"]);
          
          this.id_fabricante = params["id"];
          this.nome = fabricante.nome;
          this.cnpj = fabricante.cnpj;
          this.telefone = fabricante.telefone;
          this.email = fabricante.email;
          this.endereco = fabricante.endereco;
          this.flg_status = fabricante.flg_status || 1;
        } catch (error) {
          console.error('Erro ao carregar fabricante:', error);
          Swal.fire({
            title: "Erro!",
            text: "Não foi possível carregar os dados do fabricante.",
            icon: "error",
            confirmButtonText: "Ok"
          }).then(() => {
            this._router.navigate(['fabricante']);
          });
        }
      });

      this.contentHeader = {
        headerTitle: "Editar Fabricante",
        actionButton: false,
        breadcrumb: {
          type: "",
          links: [
            { name: "Início", isLink: false },
            { name: "Fabricante", isLink: false },
            { name: "Editar", isLink: false }
          ]
        }
      };
    }
  }

  public async submitForm(form: NgForm) {
    if (form.form.valid) {
      this.isLoading = true;
      try {
        const isCreate = this.href.value[1].path === "cadastro";
        const message = isCreate ? "cadastrado" : "atualizado";
        
        const response = isCreate
          ? await this.fabricanteService.post(form.value)
          : await this.fabricanteService.patch(form.value, this.id_fabricante);

        await Swal.fire({
          title: "Sucesso!",
          text: `O fabricante foi ${message}.`,
          icon: "success",
          confirmButtonText: "Confirmar"
        });
        
        this._router.navigate(['fabricante']);
      } catch (error) {
        console.error('Erro na operação:', error);
        await Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro ao processar a requisição.",
          icon: "error",
          confirmButtonText: "Ok"
        });
      } finally {
        this.isLoading = false;
      }
    }
  }

  ngOnDestroy() {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }
}
